import { render, staticRenderFns } from "./BussOffline.vue?vue&type=template&id=dca9011c&scoped=true&"
import script from "./BussOffline.vue?vue&type=script&lang=js&"
export * from "./BussOffline.vue?vue&type=script&lang=js&"
import style0 from "./BussOffline.vue?vue&type=style&index=0&id=dca9011c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dca9011c",
  null
  
)

export default component.exports